import { Yii } from "libraries/interfaces/Yii";
import { QuotationBlockCategoryCodeEnum } from "libraries/interfaces/quotation-block-category-code.enum";
export interface IBlockCategoryConfig {
    code: QuotationBlockCategoryCodeEnum;
    icon: string;
    wording: string;
}

export const defaultBlockCategoryConfig: IBlockCategoryConfig[] = [
    {
        code: QuotationBlockCategoryCodeEnum.price,
        icon: "fa fa-dollar",
        wording: Yii.t('wui-quotation-js', "Prix"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.transportation,
        icon: "fa fa-arrow-right",
        wording: Yii.t('wui-quotation-js', "Transport"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.activity,
        icon: "fa fa-camera",
        wording: Yii.t('wui-quotation-js', "Activit\u00e9"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.goodToKnow,
        icon: "fa fa-info",
        wording: Yii.t('wui-quotation-js', "Expertise"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.miscellaneous,
        icon: "fa fa-align-center",
        wording: Yii.t('wui-quotation-js', "Divers"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.accomodation,
        icon: "fa fa-bed",
        wording: Yii.t('wui-quotation-js', "H\u00e9bergement"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.car,
        icon: "fa fa-car",
        wording: Yii.t('wui-quotation-js', "Location de voiture"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.place,
        icon: "fa fa fa-map-marker",
        wording: Yii.t('wui-quotation-js', "Lieux"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.meal,
        icon: "fa fa-cutlery",
        wording: Yii.t('wui-quotation-js', "Repas"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.strongPoint,
        icon: "fa fa-hand-o-right",
        wording: Yii.t('wui-quotation-js', "Temps fort"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.salesPolicy,
        icon: "fa fa-list-alt",
        wording: Yii.t('wui-quotation-js', "Prix et conditions"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.notIncludedPrice,
        icon: "fa fa-square-o",
        wording: Yii.t('wui-quotation-js', "En option"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.includedPrice,
        icon: "fa fa-check-square",
        wording: Yii.t('wui-quotation-js', "Inclus"),
    },
    {
        code: QuotationBlockCategoryCodeEnum.insurance,
        icon: "fa fa-shield",
        wording: Yii.t('wui-quotation-js', "Assurance"),
    }
];
